import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus14() {
  return (
    <BusDetailsCard
      busId="bus14"
      title="Bus 14 - Route Details"
      busName="Bus 14"
      vehicleNo="TN74N4234"
      backTo="/?buses=1"
    />
  );
}